import { PresenceAvatarStack } from '@/components/common/presence-avatar-stack';
import { useCollaborationPresence } from '@/hooks/use-collaboration-presence';
import { scrollToCollaborationUser } from '@/lib/collaboration-user-scroll';
import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import type { Editor } from '@tiptap/react';

type CollaborationPresenceProps = {
    collabProvider: TiptapCollabProvider | null;
    editor: Editor | null;
};

export function CollaborationPresence({ collabProvider, editor }: CollaborationPresenceProps) {
    const users = useCollaborationPresence(collabProvider);

    if (users.length === 0) {
        return null;
    }

    return (
        <div className="flex shrink-0 items-center gap-2">
            <PresenceAvatarStack
                users={users}
                maxVisible={10}
                size="md"
                ariaLabel="Editors in this document"
                onUserClick={user => {
                    if (!editor || !collabProvider) {
                        return;
                    }
                    scrollToCollaborationUser(editor, collabProvider, user);
                }}
            />
        </div>
    );
}
